import './home.styles';

import initBlogLayout from '@/layouts/blog/blog-layout';
import initPage from '@/scripts/init/init';
import ImgLazyLoad from '@/scripts/lib/ImgLazyLoad';
import Slider from '@/scripts/lib/slider/Slider';

const $page = document.querySelector('.hp-js');

initPage();
initBlogLayout();
new ImgLazyLoad($page.querySelectorAll('img.lazy'));
new Slider($page.querySelector('.featured-js'));

(function setHumEvents() {
   if (!window.humTracker) return;

   humTracker.trackScroll($page, 'home scroll');
   humTracker.trackView($page.querySelector('.featured-js'), 'view featured');
});